<template>
  <div class="py-2">
    <div v-if="withIcon" class="mt-2 d-flex align-items-center font-24 text-success">
      <span class="icon mr-2 icon-alert_success" aria-hidden="true"></span>
      <span>{{ message }}</span>
    </div>
    <span v-else class="font-weight-bold">
      {{ message }}
    </span>
  </div>
  <slot></slot>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'FeedbackMessage',
  props: {
    message: {
      type: String,
      required: true
    },
    withIcon: {
      type: Boolean,
      default: false
    }
  }
});
</script>
